export default "__VITE_PUBLIC_ASSET__0a9f4866__"